import React, { useState } from 'react'

export function FillBlankAnswerForm({ q, answer, onChange }) {
  const lines = Array.isArray(q.payload?.lines) ? q.payload.lines : []
  const lineAnswers = Array.isArray(answer?.lines) ? answer.lines : []

  // Local state per line so typing does not depend on parent re-renders
  const [localLines, setLocalLines] = useState(() =>
    lines.map((_, idx) => (lineAnswers[idx]?.value != null ? lineAnswers[idx].value : ''))
  )

  return (
    <div style={{ display: 'grid', gap: 8 }}>
      {lines.map((l, idx) => (
        <div key={idx} style={{ display: 'grid', gap: 4 }}>
          <div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
            <div style={{ minWidth: 28, color: '#111827', fontWeight: 700 }}>{idx + 1}-</div>
            <div style={{ fontSize: 13, color: '#111827', whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
              {l?.text || ''}
            </div>
          </div>
          <input
            value={localLines[idx] || ''}
            onChange={e => {
              const next = [...localLines]
              next[idx] = e.target.value
              setLocalLines(next)
            }}
            onBlur={e => {
              const nextLines = [...lineAnswers]
              nextLines[idx] = { value: e.target.value }
              onChange(q, { lines: nextLines })
            }}
            onMouseDown={e => e.stopPropagation()}
            style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #e5e7eb' }}
          />
        </div>
      ))}
    </div>
  )
}
